import { Outlet } from "react-router-dom";
import Layout from "@/components/Layout";

export default function SiteLayoutWrapper() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
